module.exports = __webpack_public_path__ + "static/media/greenSmiley.7d1473c2.png";